import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { UINewThemeService, UISVGIconComponent, UITooltipDirective } from '@bannerflow/ui';
import { ICreative } from '@domain/creativeset/creative';
import { HeavyAssetsService } from '@studio/common/heavy-assets';

@Component({
    selector: 'lib-heavy-asset-indicator',
    imports: [UISVGIconComponent, UITooltipDirective],
    styleUrls: ['./heavy-asset-indicator.component.scss', './heavy-asset-indicator.new.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        @if (hasHeavyAsset()) {
            <div
                class="indicator-wrapper"
                uiTooltip="This creative uses a video that is over {{
                    heavyVideoLimit().mb
                }} MB.<br/> It can not be used for display ads, <a href='https://support.bannerflow.com/en/articles/6401112-working-with-heavy-videos' target='_blank'>read more here</a>."
                uiTooltipPosition="bottom"
                [uiTooltipOffset]="{ x: 0, y: 2 }"
                [uiTooltipHideArrow]="!isNewUI()">
                <ui-svg-icon
                    class="indicator"
                    [icon]="'video-heavy'"
                    [nuiIcon]="'video_settings'"
                    size="xs" />
            </div>
        }
    `,
    host: {
        '[class.hidden]': '!hasHeavyAsset()'
    }
})
export class HeavyVideoIndicatorComponent {
    private uiNewThemeService = inject(UINewThemeService);
    private heavyAssetService = inject(HeavyAssetsService);

    creative = input<ICreative>();

    hasHeavyAsset = computed(() => this.computeHasHeavyAsset());
    heavyVideoLimit = this.heavyAssetService.heavyVideoSizeLimit;
    isNewUI = this.uiNewThemeService.isNewThemeEnabled;

    private computeHasHeavyAsset(): boolean {
        const creative = this.creative();
        if (!creative) {
            return false;
        }
        const metadata = this.heavyAssetService.heavyAssetsData();

        const metadataForCreative = metadata[creative.id];
        if (!metadataForCreative?.length) {
            return false;
        }
        const limit = this.heavyVideoLimit();
        return metadataForCreative.some(({ contentLength }) => contentLength > limit.bytes);
    }
}
